import * as users from "./users";

export default {
    users
};
